import { useEffect, useState } from "react";
import Footer from "../connected/Footer";
import Navbar from "../connected/Navbar";
import PageHeader from "../primitive/PageHeader";
import SmartguardLogo from "../../assets/icons/smartguard.svg";
import ArrowRight from "../../assets/icons/arrow-right.svg";
// import WindowLogo from "../../assets/icons/window.svg";
// import MacLogo from "../../assets/icons/mac.svg";
// import LinuxLogo from "../../assets/icons/linux.svg";
// import ImportIcon from "../../assets/icons/import.svg";
// import StartLineIcon from "../../assets/icons/straight-line.svg";
import axios from "axios";
import { Link } from "react-router-dom";
import moment from "moment/moment";
import { useTranslation } from "react-i18next";

const Smartguard = () => {
  const [os, setOS] = useState("your OS");
  const [fetching, setFetching] = useState(false);
  const [versions, setVersions] = useState([]);

  const { t } = useTranslation("smartguard");

  const detectOS = () => {
    const { userAgent, platform } = navigator;
    const macos = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"];
    const windows = ["Win32", "Win64", "Windows", "WinCE"];
    const ios = ["iPhone", "iPad", "iPod"];

    if (macos.includes(platform)) return "mac";
    if (ios.includes(platform)) return "iOS";
    if (windows.includes(platform)) return "Windows";
    if (/Android/.test(userAgent)) return "Android";
    if (/Linux/.test(platform)) return "Linux";
    return "your OS";
  };
  useEffect(() => {
    setOS(detectOS());
  }, []);
  //async actions
  const fetchAllVersions = async () => {
    setFetching(true);
    try {
      const res = await axios.get(
        "https://api.smartcomplyapp.com/api/smartguard/version/",
        {
          params: {
            platform: os?.toLowerCase(),
            page_size: 30,
          },
        },
      );

      if (res.status === 200) {
        setVersions(res.data.results);
      }
    } finally {
      setFetching(false);
    }
  };

  useEffect(() => {
    if (os !== "your OS") {
      fetchAllVersions();
    }
  }, [os]);

  // const downloadLinks = {
  //   Windows: "/downloads/Smartguard-Windows.exe",
  //   macOS: "/downloads/Smartguard-Mac.dmg",
  //   Linux: "/downloads/Smartguard-Linux.tar.gz",
  // };
  // const link = downloadLinks[os] || "#";
  const link = versions?.sort(
    (a, b) =>
      new Date(b?.date_created).getTime() - new Date(a?.date_created).getTime(),
  )?.[0]?.link;
  //   is This a correct thing to say
  //  By using Smartguard, you agree to the terms of use
  // const versions1 = [
  //   {
  //     version: "v2.3.1",
  //     date: "2026-01-13T19:16:00.188802",
  //     notes: "Bug fixes and performance improvements",
  //     links: {
  //       mac: "https://example.com/smartguard-2.3.1-mac.dmg",
  //       windows: "https://example.com/smartguard-2.3.1-win.exe",
  //     },
  //   },
  //   {
  //     version: "v2.2.0",
  //     date: "2026-01-13T19:16:00.188802",
  //     notes: "Improved threat scanning and UI updates",
  //     links: {
  //       mac: "https://example.com/smartguard-2.2.0-mac.dmg",
  //       windows: "https://example.com/smartguard-2.2.0-win.exe",
  //     },
  //   },
  // ];
  return (
    <div>
      <PageHeader browserTitle="Smartguard | Smartcomply Secure" />

      {fetching ? (
        <SmartguardSkeleton />
      ) : (
        <div className="home_hero_bg_img">
          <Navbar />
          <div className="md:my-[4rem] my-[2rem]">
            <div className="text-center flex justify-center items-center flex-col gap-3">
              <img src={SmartguardLogo} alt="SmartguardLogo" />
              <h1 className="md:text-[62px] text-3xl font-bold">
                {t("title")}
              </h1>
              <p className="text-[#475569] text-base max-w-md mx-auto md:block hidden mt-3">
                {t("desc1")} <br />
                {t("desc2")} <br />
                {t("desc3")}
              </p>
              <p className="text-[#475569] text-base max-w-md mx-auto md:hidden block mt-3">
                {t("description")}
              </p>
              {link ? (
                <a href={link} target="_blank" rel="noreferrer">
                  <button className="flex justify-center items-center gap-3 bg-[#0A0B26] rounded-full text-white text-lg py-2.5 px-6 w-[348px] mt-3 uppercase font-normal">
                    <span>
                      {t("cta")} {os}
                    </span>
                    <img src={ArrowRight} alt="ArrowRight" />
                  </button>
                </a>
              ) : (
                <button
                  disabled
                  className="flex justify-center items-center gap-3 bg-gray-300 rounded-full text-gray-600 text-lg py-2.5 px-6 w-[348px] mt-3 uppercase font-normal cursor-not-allowed"
                >
                  <span>{t("comingSoon")}</span>
                </button>
              )}
            </div>

            <div className="container mx-auto py-5 flex justify-center  flex-row items-center space-x-5 mt-5 text-xs">
              <p>
                {t("text")}{" "}
                <span className="text-black border-b border-black mr-1">
                  <Link to="/terms"> {t("terms")} </Link>
                </span>{" "}
                {t("and")}{" "}
                <span className="text-black border-b border-black ml-1">
                  <Link to="/privacy"> {t("privacy")}</Link>
                </span>{" "}
              </p>
            </div>
            {versions?.results?.length > 1 && (
              <div className="container mx-auto mt-10 max-w-3xl">
                <details className="bg-[#0A0B26] rounded-xl p-5">
                  <summary className="cursor-pointer text-sm font-medium text-white text-center">
                    {t("previousVersions")}
                  </summary>

                  <div className="mt-4 space-y-4">
                    {versions?.results?.map((v) => (
                      <div
                        key={v.version}
                        className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 border-b pb-4"
                      >
                        <div>
                          <p className="font-semibold text-white">
                            {v.version}
                          </p>
                          <p className="text-xs text-white">
                            {t("released")}{" "}
                            {moment(v?.date_created).format("MMM DD, YYYY")}
                          </p>
                          <p className="text-xs text-white mt-1">
                            {v?.release_notes}
                          </p>
                        </div>

                        <div className="flex gap-3">
                          {v?.link && (
                            <a
                              href={v.links[os.toLowerCase()]}
                              target="_blank"
                              rel="noreferrer"
                              className="text-xs px-4 py-2 rounded-full border border-slate-300 hover:bg-slate-100 text-white"
                            >
                              {t("cta")} {v?.platform}
                            </a>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </details>
              </div>
            )}

            {/* Download Card Section */}
            {/* <div className="flex justify-center items-center xl:h-[45vh] md:h-[60vh]">
              <div className="xl:w-[80%] md:w-[50%] flex justify-center items-center flex-col gap-3">
                <div className="">
                  <div className="flex items0center gap-2 mb-5">
                    <img src={StartLineIcon} alt="StartLineIcon" />
                    <p className="text-[#334155] text-base !font-semibold">
                      Not your OS?
                    </p>
                  </div>
                  <div className="flex flex-col sm:flex-row gap-6 mb-10">
                    <div className="bg-[#0A0B26] shadow-md rounded-[24px] px-3 py-5 w-[313px] h-[230px] text-center">
                      <h3 className="text-white text-center mb-4 text-xl font-semibold">
                        COMING SOON !
                      </h3>
                      <img src={WindowLogo} alt="WindowLogo" />
                      <div className="mt-5 flex justify-center items-center gap-3 flex-col">
                        <button
                          className="flex justify-center items-center gap-3 bg-[#212236] rounded-full py-1.5 w-full text-white tetx-sm font-medium"
                          disabled
                        >
                          <img src={ImportIcon} alt="ImportIcon" />
                          <span>Download x64</span>
                        </button>
                        <button
                          className="flex justify-center items-center gap-3 bg-[#212236] rounded-full py-1.5 w-full text-white tetx-sm font-medium"
                          disabled
                        >
                          <img src={ImportIcon} alt="ImportIcon" />
                          <span>Download x32</span>
                        </button>
                      </div>
                    </div>
                    <div className="bg-[#0A0B26] shadow-md rounded-[24px] px-3 py-5 w-[313px] h-[230px] text-center">
                      <h3 className="text-white text-center mb-4 text-xl font-semibold">
                        COMING SOON !
                      </h3>
                      <img src={MacLogo} alt="MacLogo" />
                      <div className="mt-5 flex justify-center items-center gap-3 flex-col">
                        <button
                          className="flex justify-center items-center gap-3 bg-[#212236] rounded-full py-1.5 w-full text-white tetx-sm font-medium"
                          disabled
                        >
                          <img src={ImportIcon} alt="ImportIcon" />
                          <span>Apple Silicon</span>
                        </button>
                        <button
                          className="flex justify-center items-center gap-3 bg-[#212236] rounded-full py-1.5 w-full text-white tetx-sm font-medium"
                          disabled
                        >
                          <img src={ImportIcon} alt="ImportIcon" />
                          <span>Intel</span>
                        </button>
                      </div>
                    </div>
                    <div className="bg-[#0A0B26] shadow-md rounded-[24px] px-3 py-5 w-[313px] h-[230px] text-center">
                      <h3 className="text-white text-center mb-4 text-xl font-semibold">
                        COMING SOON !
                      </h3>
                      <img src={LinuxLogo} alt="LinuxLogo" />
                      <div className="mt-5 flex justify-center items-center gap-3 flex-col">
                        <button
                          className="flex justify-center items-center gap-3 bg-[#212236] rounded-full py-1.5 w-full text-white tetx-sm font-medium"
                          disabled
                        >
                          <img src={ImportIcon} alt="ImportIcon" />
                          <span>Debian Package</span>
                        </button>
                        <button
                          className="flex justify-center items-center gap-3 bg-[#212236] rounded-full py-1.5 w-full text-white tetx-sm font-medium"
                          disabled
                        >
                          <img src={ImportIcon} alt="ImportIcon" />
                          <span>RPM Package</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>

          <Footer />
        </div>
      )}
    </div>
  );
};
const Skeleton = ({ className = "" }) => {
  return (
    <div
      className={`animate-pulse bg-gray-200 dark:bg-gray-700 rounded-md ${className}`}
    />
  );
};

const SmartguardSkeleton = () => {
  return (
    <div className="md:my-[4rem] my-[2rem]">
      <div className="text-center flex justify-center items-center flex-col gap-4">
        {/* Logo */}
        <Skeleton className="w-[140px] h-[40px]" />

        {/* Title */}
        <Skeleton className="w-[300px] h-[50px]" />

        {/* Description */}
        <Skeleton className="w-[500px] h-[20px]" />
        <Skeleton className="w-[450px] h-[20px]" />

        {/* Download button */}
        <Skeleton className="w-[348px] h-[50px] rounded-full mt-4" />
      </div>

      {/* Cards */}
      {/* <div className="flex justify-center items-center xl:h-[45vh] md:h-[60vh] mt-12">
        <div className="flex flex-col sm:flex-row gap-6">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="bg-[#0A0B26] rounded-[24px] px-3 py-5 w-[313px] h-[280px]"
            >
              <Skeleton className="w-[140px] h-[24px] mx-auto mb-6" />
              <Skeleton className="w-[80px] h-[80px] mx-auto mb-6 rounded-full" />
              <Skeleton className="w-full h-[36px] rounded-full mb-3" />
              <Skeleton className="w-full h-[36px] rounded-full" />
            </div>
          ))}
        </div>
      </div> */}
    </div>
  );
};

export default Smartguard;
